import React from "react";
import { Plus } from "lucide-react";

export const PanelAddButton = ({ onClick, label }) => (
  <div className="group relative flex shrink-0 items-center">
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="flex h-6 w-6 items-center justify-center rounded border border-slate-600 text-slate-300 transition-colors hover:border-teal-400 hover:bg-slate-800 hover:text-teal-300"
    >
      <Plus size={14} strokeWidth={2} />
    </button>
    <span className="pointer-events-none absolute right-full top-1/2 z-[300] mr-2 -translate-y-1/2 whitespace-nowrap rounded border border-slate-700 bg-slate-800 px-2 py-1 text-[0.65rem] font-medium normal-case tracking-normal text-slate-100 opacity-0 shadow-lg transition-opacity group-hover:opacity-100">
      {label}
    </span>
  </div>
);

export const PanelScopeToggle = ({ value = "active", onChange, label = "List filter" }) => (
  <div
    className="flex shrink-0 overflow-hidden rounded-md border border-slate-700 bg-slate-950/60 p-0.5"
    role="group"
    aria-label={label}
  >
    {[
      ["active", "Active"],
      ["all", "All"],
    ].map(([option, optionLabel]) => (
      <button
        key={option}
        type="button"
        aria-pressed={value === option}
        onClick={() => onChange && onChange(option)}
        className={`rounded px-1.5 py-0.5 text-[0.55rem] font-semibold transition-colors ${
          value === option
            ? "bg-teal-500/20 text-teal-300"
            : "text-slate-500 hover:text-slate-300"
        }`}
      >
        {optionLabel}
      </button>
    ))}
  </div>
);

const PanelListHeader = ({ title, count = null, onAdd = null, addLabel = "New" }) => (
  <div className="flex min-h-7 items-center justify-between gap-2 px-1">
    <div className="truncate text-[0.7rem] font-semibold text-slate-300">
      {title}{count !== null ? ` (${count})` : ""}
    </div>
    {onAdd && (
      <PanelAddButton onClick={onAdd} label={addLabel} />
    )}
  </div>
);

export default PanelListHeader;
